import axios from './../../utils/Api'
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
 GET_RECRUITER
} from "../actions";
import qs from "qs";
import {
  getRecruiterSuccess,
  getRecruiterError,
  
} from "./actions";
import download from "downloadjs";

import Moment from "moment";
export function* watchGetRecruiter() {
  yield takeEvery(GET_RECRUITER, getRecruiterNow);
}

  
// const getrecruiter = (state) => state.Auth.authUser.email
const getRecruiterNowAsync = async () =>
  await axios.get(`auth/recruiters/tlc`)
    .then(({ data }) => {
      console.log(data)
      return data;
    })
    .catch(function(error) {
      console.log(error);
      return error.response.data;
    });

function* getRecruiterNow() {
  try {
    axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem("ats_user_token");
    const response = yield call(getRecruiterNowAsync);
    if (response) {
      console.log(response.data)
      yield put(getRecruiterSuccess(response.data));
    } else {
      yield put(getRecruiterError(response));
    }
  } catch (error) {
    console.log(error);
    yield put(getRecruiterError(error.message));
  }
}


export default function* rootSaga() {
  yield all([
    fork(watchGetRecruiter)
    
  ]);
}
